import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Arquivos } from '../../../pages';
import UploadProvider from '../../../contexts/UploadContext';

const ArquivosRoutes = () => {
  return (
    <UploadProvider>
      <Routes>
        <Route path="/" element={<Arquivos />} />
      </Routes>
    </UploadProvider>
  );
};

export default ArquivosRoutes;
